export default __webpack_public_path__ + "static/media/(6).dba89c9b.jpeg";